import React from "react";
import "./LogoCarousel.css"; // We'll write CSS here

const logos = [
  "/Images/Incubators/logo1.png",
  "/Images/Incubators/logo2.png",
  "/Images/Incubators/logo3.png",
  "/Images/Incubators/logo7.png",
  "/Images/Incubators/logo4.png",
  "/Images/Incubators/logo5.png",
  "/Images/Incubators/logo6.png",
  "/Images/Incubators/logo8.png",

  // Add as many logos as needed
];

const LogoCarousel = () => {
  // Duplicate logos for seamless infinite scroll
  const allLogos = [...logos, ...logos];

  return (
    <div className="logo-carousel-wrapper">
      <h2 className="carousel-heading">
        Our <span>Incubators</span>{" "}
      </h2>
      <div className="logo-carousel">
        <div className="logo-track">
          {allLogos.map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt={`logo-${index}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoCarousel;
